import { CSSProperties } from 'react'

export const s = {
  successButton: {
    borderColor: '#187759',
    backgroundColor: '#187759',
  } as CSSProperties,
}
